import { useState } from 'react';
import { Button, Icon, Txt } from '@vst/beam';
import {
  AccountCircleOutlined,
  ChevronDownCurved,
} from '@vst/beam-icons/icons';

import ProfileHover from '../ProfileHover';

import { NavItem } from '../types';

import styles from './styles.module.scss';

type ProfileButtonProps = {
  navigationTab: NavItem;
  createNavItemClickHandler: (
    link: string
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const ProfileButton = ({
  navigationTab,
  createNavItemClickHandler,
}: ProfileButtonProps): JSX.Element => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const handleAccountOpen = <E extends React.SyntheticEvent>(e: E) => {
    e.preventDefault();
    setIsProfileOpen(!isProfileOpen);
  };

  const chevronIconClassName = isProfileOpen
    ? `${styles.chevron} ${styles.flip}`
    : styles.chevron;

  return (
    <>
      <Button
        variant="tertiary"
        className={styles.profileTabButton}
        data-cy={'/Account'}
        onClick={handleAccountOpen}
      >
        <Icon icon={AccountCircleOutlined} size={24} color="gray_500" />
        <Txt variant="bodySmallRegular" color="subtle">
          {navigationTab.label}
        </Txt>
        <Icon
          icon={ChevronDownCurved}
          size={26}
          color="gray_500"
          className={chevronIconClassName}
        />
      </Button>
      {isProfileOpen && (
        <ProfileHover
          isProfileOpen={isProfileOpen}
          setIsProfileOpen={setIsProfileOpen}
          createNavItemClickHandler={createNavItemClickHandler}
        />
      )}
    </>
  );
};

export default ProfileButton;
